module.exports = __webpack_public_path__ + "assets/images/branch/cases/i3.png";